import { render, staticRenderFns } from "./NewGroupSide.vue?vue&type=template&id=9fff32cc&scoped=true&"
import script from "./NewGroupSide.vue?vue&type=script&lang=js&"
export * from "./NewGroupSide.vue?vue&type=script&lang=js&"
import style0 from "./NewGroupSide.vue?vue&type=style&index=0&id=9fff32cc&lang=scss&scoped=true&"
import style1 from "./NewGroupSide.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fff32cc",
  null
  
)

export default component.exports